export { AdminPage } from './AdminPage'
export { adminSagas } from './sagas'
export { adminPageReducer } from './reducers'


// WEBPACK FOOTER //
// ./src/App/Admin/index.js